<template>
      <transition name="modal">
        <div class="modal-mask2" >
          <div class="modal-wrapper2" >
            <div class="modal-container2" ref="modalContainer" @scroll="$emit('scroll')">

              <div class="modal-header2">
                <slot name="header">
                  <button class="btn btn-danger float-right"  @click="$emit('close')">
                    <i class="fas fa-times"></i>
                  </button>
                </slot>
              </div>

              <div class="modal-body2">
                <slot name="body">
                  default body
                </slot>
              </div>

              <!-- <div class="modal-footer">
                <slot name="footer">
                   
                  <button class="btn btn-secondary" @click="$emit('close')">
                    OK
                  </button>
                </slot>
              </div> -->
            </div>
          </div>
        </div>
      </transition>
</template>

<style scoped>
.modal-mask2 {
  position: fixed;
  z-index: 990;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper2 {

  display: table-cell;
  vertical-align: middle;
}

.modal-container2 {
  width: 99vw;
  height: 100%;
 
  padding:  20px ;
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  overflow: scroll;
  
}

.modal-header2 h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body2 {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>

 